<template>
  <slot v-if="doc" v-bind="{ doc }" />
</template>

<script setup lang="ts" generic="T extends PayloadCollection">
interface PayloadDocResolverProps {
  doc: string | T
}

const props = defineProps<PayloadDocResolverProps>()
const doc = useRelationshipField(props.doc)
</script>
